import { render, staticRenderFns } from "./FriendshipLink.vue?vue&type=template&id=de2e3ac8&scoped=true&"
import script from "./FriendshipLink.vue?vue&type=script&lang=js&"
export * from "./FriendshipLink.vue?vue&type=script&lang=js&"
import style0 from "./FriendshipLink.vue?vue&type=style&index=0&id=de2e3ac8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2e3ac8",
  null
  
)

export default component.exports